import React from 'react';
import PropTypes from 'prop-types';
import { StyledText } from './components/TypographyStyles';
import { useTypography } from './hooks/useTypography';

const Typography = ({ variant, size, color, children, as, ...rest }) => {
  const { asTag } = useTypography({ variant, as });

  return (
    <StyledText as={asTag} variant={variant} size={size} color={color} {...rest}>
      {children}
    </StyledText>
  );
};

Typography.propTypes = {
  variant: PropTypes.oneOf([
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'display1', 'display2', 'display3', 'display4', 'display5', 'display6',
    'lead', 'large', 'medium', 'small', 'xsText',
    'cardTitle', 'articleTitle', 'articleSubtitle', 'paragraph',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  color: PropTypes.string,
  as: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Typography.defaultProps = {
  size: 'sm',
  as: undefined,
  variant: undefined,
  color: undefined,
};

export default Typography;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Typography/Typography.jsx